'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/UserPlus.es.js";
const o = a.forwardRef((r, s) => /* @__PURE__ */ a.createElement(p, { ref: s, ...r, weights: e }));
o.displayName = "UserPlusIcon";
const n = o;
export {
  n as UserPlus,
  o as UserPlusIcon
};
